import { render } from "./LoadingView.vue?vue&type=template&id=0a474a44&scoped=true"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=0a474a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a474a44"]])

export default __exports__